// removed by extract-text-webpack-plugin
module.exports = {"container":"general__container___3gViq inline"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-grid/InlineGrid/style/general.css
// module id = 12
// module chunks = 0 1 2 3 6